//--------------------------------------------------------------------------------------------------
//# Imports

import React, { useEffect, useContext } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
// To be added back later
// import SmartContractContext from '../../scripts/SmartContractContext';
import Aos from "aos";
import "aos/dist/aos.css";

//import walletButton from '../../image/button_4x1.png'
//import connectWallet from '../../scripts/SmartContractOperator';

import logo from '../../image/logo.webp'

// import twitter_icon from '../../image/icons/twitter.webp'
// import linkedin_icon from '../../image/icons/linkedin.webp'
// import instagram_icon from '../../image/icons/instagram.webp'
// import discord_icon from '../../image/icons/discord.webp'

import early_access_button from '../../image/get-early-access-button.webp'

import { useAccountOperator } from "../../scripts/AccountOperator";

import shadow_avatar from '../../image/team-image-3.webp'

import './adminnavbar.css'











//--------------------------------------------------------------------------------------------------
//# Variables

const connect_on_load = false;

var mobile = false;
if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
  console.log("Mobile device detected");
  mobile = true;
};

const delay_gap = 200;


//AppStart
const AdminNavbar = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { ready, authenticated, login, logout, user, backendUser } = useAccountOperator();

  const avatar_URL = backendUser?.avatar_URL;

// To be added back later
// let { user_address, setAddress_Context } = useContext(SmartContractContext);
// let { user_token_ID, setTokenID_Context } = useContext(SmartContractContext);
// let { user_balance, setBalance_Context } = useContext(SmartContractContext);
// let { user_metadata, setMetadata_Context } = useContext(SmartContractContext);
// let { user_avatar_URI, setAvatarURI_Context } = useContext(SmartContractContext);









//--------------------------------------------------------------------------------------------------
//# Functions

  useEffect(() => {
    Aos.init({ duration: 2000 });

    // Reset AOS attributes after animation finishes
    setTimeout(() => {
      const buttons = document.querySelectorAll('.adminNavbarCenterButton, .adminNavbarEarlyAccessButton, .adminNavbarRightButton');
      buttons.forEach(button => {
        button.addEventListener('mouseenter', () => {
          button.style.transform = 'scale(1.15)';
          button.style.transition = 'transform 0.5s ease-in-out';
        });

        button.addEventListener('mousedown', () => {
          button.style.transform = 'scale(1.3)';
          button.style.transition = 'transform 0.05s ease-in-out';
        });
    
        button.addEventListener('mouseleave', () => {
          button.style.transform = 'scale(1.0)';
          button.style.transition = 'transform 0.5s ease-in-out';
        });
      });
    }, 1000);  // Match to AOS duration
  }, []);

  function mouseOver(event) {
    let element = document.getElementById(event.target.id);
    element.style.transform = 'scale(1.20)';
  }

  function mouseLeave(event) {
    let element = document.getElementById(event.target.id);
    element.style.transform = 'scale(1.0)';
  }

  function handleClick(event) {
    console.log('1');
    let id = event.target.id;

    if (id === 'adminLogOut') {
      logOutAdmin();
      console.log('3');
    };

    // const sectionMap = {
    //   adminNavbarAlchmizer: "alchmizerOverview",
    //   adminNavbarBirthChart: "roadmap",
    //   adminNavbarGraphs: "team",
    //   adminNavbarLinks: "faq"
    // };

    // const target_section = sectionMap[id];
    // if (!target_section) return;
    // if (pathname !== "/") {
    //   navigate(`/?scrollTo=${target_section}`);
    //   return;
    // };

    // scrollToSection(target_section);
  };

  function scrollToSection(className) {
    const elem = document.getElementsByClassName(className)[0];
    if (!elem) return;
    window.scroll({
      behavior: "smooth",
      top: elem.offsetTop,
    });
  };

  function logOutAdmin() {
    console.log('2');
    logout();
    console.log('2.5');
    navigate("/admin/login");
    console.log('2.99');
  };







//--------------------------------------------------------------------------------------------------
//# HTML

return (
  <div className='adminNavbar' id="anchorElement_AdminNavbar">
    <div className='adminNavbarContainer'>
      <div className='adminNavbarLeft'>
        {/* <div id="adminNavbarLogo" className='adminNavbarLogo'>
          <a href={window.location['origin'] + '/admin/console'}>
            <img className="adminNavbarLogoImage" id="adminNavbarLogoImage" src={logo} alt='Home' onMouseOver={mouseOver} onMouseLeave={mouseLeave}
              data-aos="fade-down-right" data-aos-anchor-placement="top-center" data-aos-anchor="#anchorElement_AdminNavbar"/>
          </a>
        </div> */}
      </div>
      <div className='adminNavbarCenter'>
        {/* <div id='adminNavbarHome' className='adminNavbarCenterButton' onClick={handleClick}
          data-aos="fade-down-right" data-aos-delay={1 * delay_gap} data-aos-anchor-placement="top-center" data-aos-anchor="#anchorElement_AdminNavbar">
            Home
        </div>
        <div id='adminNavbarAlchmizer' className='adminNavbarCenterButton' onClick={handleClick}
          data-aos="fade-down-right" data-aos-delay={2 * delay_gap} data-aos-anchor-placement="top-center" data-aos-anchor="#anchorElement_AdminNavbar">
            Alchmizer
        </div>
        <div id='adminNavbarBirthChart' className='adminNavbarCenterButton' onClick={handleClick}
          data-aos="fade-down" data-aos-delay={3 * delay_gap} data-aos-anchor-placement="top-center" data-aos-anchor="#anchorElement_AdminNavbar">
            Birth Chart
        </div>
        <div id='adminNavbarGraphs' className='adminNavbarCenterButton' onClick={handleClick}
          data-aos="fade-down-left" data-aos-delay={4 * delay_gap} data-aos-anchor-placement="top-center" data-aos-anchor="#anchorElement_AdminNavbar">
            Graphs
        </div>
        <div id='adminNavbarLinks' className='adminNavbarCenterButton' onClick={handleClick}
          data-aos="fade-down-left" data-aos-delay={5 * delay_gap} data-aos-anchor-placement="top-center" data-aos-anchor="#anchorElement_AdminNavbar">
            Links
        </div> */}
        {/* <div className='adminNavbarEarlyAccessContainer'>
          <img id='adminNavbarEarlyAccessButton' className='adminNavbarEarlyAccessButton adminNavbarEarlyAccessCenterButton' src={early_access_button} onMouseOver={mouseOver} onMouseLeave={mouseLeave} onClick={handleClick}
            data-aos="fade-down" data-aos-delay="1000" data-aos-anchor-placement="top-center" data-aos-anchor="#anchorElement_AdminNavbar"/>
        </div> */}
      </div>
      <div className='adminNavbarRight'>
        <div id='adminLogOut' className='adminNavbarTextRight adminNavbarRightButton' onClick={handleClick} onMouseOver={mouseOver} onMouseLeave={mouseLeave}
          data-aos="zoom-in" data-aos-delay={0 * delay_gap} data-aos-anchor-placement="top-center" data-aos-anchor="#anchorElement_AdminNavbar">
            Log Out
        </div>
        <img className='adminNavbarIcon instagramIcon' alt='Profile' id='instagramIcon' src={avatar_URL || shadow_avatar} onMouseOver={mouseOver} onMouseLeave={mouseLeave}
          data-aos="zoom-in" data-aos-anchor-placement="top-center" data-aos-anchor="#anchorElement_AdminNavbar"/>
        {/* <a href='https://evanon.earth/alchminstagram-alchmref' target="_blank">
          <img className='adminNavbarIcon instagramIcon' id='instagramIcon' src={instagram_icon} onMouseOver={mouseOver} onMouseLeave={mouseLeave}
            data-aos="fade-down" data-aos-anchor-placement="top-center" data-aos-anchor="#anchorElement_AdminNavbar"/>
        </a>
        <a href='https://evanon.earth/alchmx-alchmref' target="_blank">
          <img className='adminNavbarIcon twitterIcon' id='twitterIcon' src={twitter_icon} onMouseOver={mouseOver} onMouseLeave={mouseLeave}
            data-aos="fade-down-right" data-aos-anchor-placement="top-center" data-aos-anchor="#anchorElement_AdminNavbar"/>
        </a> */}
      </div>
    </div>
    {/* <div className='adminNavbarEarlyAccessContainer'>
      <img id='adminNavbarEarlyAccessButton' className='adminNavbarEarlyAccessButton adminNavbarEarlyAccessRightButton' src={early_access_button} onMouseOver={mouseOver} onMouseLeave={mouseLeave}  onClick={handleClick}
        data-aos="fade-left" data-aos-delay="1000" data-aos-anchor-placement="top-center" data-aos-anchor="#anchorElement_AdminNavbar"/>
    </div> */}
  </div>
)
}
//AppEnd

export default AdminNavbar